<nw-card class="menu-card" (raiseEvent)="onRaiseEvent($event)">
    <div role="header" class="menu-card__content">
        <nw-icon
            class="menu-card__content__icon"
            [icon]="icon"
            preserveAspectRatio="xMinYMin"
        ></nw-icon>
        <div class="menu-card__content__title">
            {{ title }}
        </div>
    </div>
    <div role="body" class="menu-card__content__text">{{ text }}</div>
</nw-card>
